import React from "react";
import "./RelatedProducts.css";
import {useSelector} from "react-redux";
import Slider from "react-slick";
import ProductCard from "../product/ProductCard";

const RelatedProducts = () => {
    const relatedProduct = useSelector((state) => state.product.productDetailData?.related_product);

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    return(
        relatedProduct?.length> 0 ?
            <div className='flex-col items-center gap-2 h-[90vh] bg-light pt-10'>
            <h1 className='text-4xl font-semibold text-center'>Related Products</h1>

            <div className='m-20 gap-12'>
                {relatedProduct.length > 0 ?
                <Slider {...settings}>
                    { relatedProduct?.map(data => {
                        return data && data.photo && <ProductCard key={data?.id} productItems={data}/>;
                    })}
                </Slider> :    <div className='grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2'> {relatedProduct?.map(data => (
                        data && data.photo && <ProductCard key={data?.id} productItems={data}/>
                    ))
                }</div>}
            </div>
        </div>
            : ''
    )
}

export default RelatedProducts
